import { render, staticRenderFns } from "./step6.vue?vue&type=template&id=09650bc3&scoped=true"
import script from "./step6.vue?vue&type=script&lang=js"
export * from "./step6.vue?vue&type=script&lang=js"
import style0 from "./step6.vue?vue&type=style&index=0&id=09650bc3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-load_bf339e0f7cd061f35bf078d2faee2298/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09650bc3",
  null
  
)

export default component.exports